import { collection, QueryDocumentSnapshot } from "firebase/firestore";

import { db } from "integrations/firebase/firestore";
import {
  FirestoreOrganisationReference,
  FirestoreUser,
} from "reedy-data/models";

export interface IUserSettings {
  visitedSearchTermsPage?: boolean;
  acceptedTermsVersion?: string;
  analyticsGroup?: string;
  keywordsPipelineInfoSeen?: boolean;
}

export type IUser = Omit<FirestoreUser, "organisation"> & {
  familyName: string;
  givenName: string;
  photoUrl?: string;
  organisation: FirestoreOrganisationReference;
  settings?: IUserSettings;
};

const userConverter = {
  toFirestore: (user: IUser) => user,
  fromFirestore(snapshot: QueryDocumentSnapshot<IUser>): IUser {
    const data = snapshot.data();

    return {
      ...data,
      id: snapshot.id,
    };
  },
};

export const getUsersCollection = () =>
  collection(db, "users").withConverter(userConverter);
